module.exports = __webpack_public_path__ + "static/media/icons-ic-google-cal.ab0178bd.svg";